import axios from 'axios';

export const requestFreeTipPurchase = (tipID: string, couponID: string) => {
  return axios.put(
    `v1/tips/${tipID}/unlock`,
    JSON.stringify({ coupon_id: couponID }),
  );
};
